(function () {
  const SELECTOR = '[data-tcn-section]';
  const EDGE_EPSILON = 8;

  function initSection(section) {
    if (!section || section.dataset.tcnBound === 'true') return;
    section.dataset.tcnBound = 'true';

    initImageHydration(section);

    const tabs = Array.from(section.querySelectorAll('[data-tcn-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-tcn-panel]'));
    const tabsWrap = section.querySelector('[data-tcn-tabs-wrap]');

    if (tabsWrap) initTabsScroll(tabsWrap);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.getAttribute('data-tcn-tab-index');
        activateTab(tabs, panels, index, () => {
          const activePanel = panels.find(
            (p) => p.getAttribute('data-tcn-panel-index') === index
          );
          if (!activePanel) return;
          const slider = activePanel.querySelector('[data-tcn-slider]');
          if (slider) resetSliderToStart(slider);
        });

        if (typeof tab.scrollIntoView === 'function') {
          tab.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      });
    });

    panels.forEach((panel) => {
      const slider = panel.querySelector('[data-tcn-slider]');
      if (slider) initSlider(slider);
    });

    section.querySelectorAll('[data-tcn-card]').forEach((card) => {
      if (card.getAttribute('data-tcn-gallery') !== 'hovered') {
        initCardMedia(card);
      }
      initCardQuickView(card);
    });
  }

  function openProductQuickView(productId) {
    if (!productId) return;
    const quickView = document.querySelector('quick-view');
    if (quickView && typeof quickView.openModal === 'function') {
      quickView.openModal(String(productId));
      return;
    }
    console.error('Quick View component not found.');
  }

  function initCardQuickView(card) {
    const productId = card.getAttribute('data-product-id');
    if (!productId) return;

    card.querySelectorAll('[data-tcn-quickview]').forEach((trigger) => {
      if (trigger.dataset.tcnQvBound === 'true') return;
      trigger.dataset.tcnQvBound = 'true';

      const onActivate = (event) => {
        // Keep media carousel controls from opening the modal
        if (
          event.target.closest(
            '[data-tcn-media-prev], [data-tcn-media-next], [data-tcn-indicator], .tcn-card__cta'
          )
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        openProductQuickView(
          trigger.getAttribute('data-product-id') || productId
        );
      };

      trigger.addEventListener('click', onActivate);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        onActivate(event);
      });
    });
  }

  function initImageHydration(section) {
    const hydrate = () => hydrateImages(section);

    if (window.Shopify && window.Shopify.designMode) {
      hydrate();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      hydrate();
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrate();
          io.disconnect();
        });
      },
      {
        root: null,
        rootMargin: '150px 0px',
        threshold: 0.01,
      }
    );

    io.observe(section);
  }

  function hydrateImages(section) {
    section.querySelectorAll('img.tcn-card__image').forEach((img) => {
      if (img.dataset.tcnHydrated === 'true') return;
      img.dataset.tcnHydrated = 'true';

      // Nudge lazy images to load once the section is in view
      if (img.loading === 'lazy') {
        img.loading = 'eager';
      }
      if (typeof img.decode === 'function') {
        img.decode().catch(() => {});
      }
    });
  }

  function activateTab(tabs, panels, index, onShown) {
    const nextPanel = panels.find(
      (panel) => panel.getAttribute('data-tcn-panel-index') === index
    );
    const currentPanel = panels.find((panel) =>
      panel.classList.contains('is-active')
    );

    if (!nextPanel || currentPanel === nextPanel) return;

    tabs.forEach((tab) => {
      const active = tab.getAttribute('data-tcn-tab-index') === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    const outMs = reduceMotion ? 0 : 220;

    const showNext = () => {
      panels.forEach((panel) => {
        const active = panel === nextPanel;
        panel.classList.toggle('is-active', active);
        panel.classList.remove('is-leaving');
        if (active) {
          panel.removeAttribute('hidden');
          // Newly shown slider cards should appear without waiting for scroll reveal
          panel.querySelectorAll('[data-reveal]').forEach((item) => {
            item.classList.add('is-revealed');
          });
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (typeof onShown === 'function') onShown();
    };

    if (!currentPanel || outMs === 0) {
      showNext();
      return;
    }

    currentPanel.classList.add('is-leaving');
    currentPanel.classList.remove('is-active');

    window.setTimeout(() => {
      currentPanel.setAttribute('hidden', '');
      currentPanel.classList.remove('is-leaving');
      showNext();
    }, outMs);
  }

  function setArrowVisibility(button, visible) {
    if (!button) return;
    button.classList.toggle('is-visible', !!visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
    if (visible) {
      button.removeAttribute('hidden');
    } else {
      button.setAttribute('hidden', '');
    }
  }

  function updateArrowVisibility(slider) {
    const track = slider.querySelector('[data-tcn-track]');
    const prev = slider.querySelector('[data-tcn-prev]');
    const next = slider.querySelector('[data-tcn-next]');
    if (!track || !prev || !next) return;

    const panel = slider.closest('[data-tcn-panel]');
    const hasCards = !!track.querySelector('.tcn-card');
    if ((panel && panel.hasAttribute('hidden')) || !hasCards) {
      setArrowVisibility(prev, false);
      setArrowVisibility(next, false);
      return;
    }

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const scrollLeft = track.scrollLeft;
    const scrollable = maxScroll > EDGE_EPSILON;

    setArrowVisibility(prev, scrollable && scrollLeft > EDGE_EPSILON);
    setArrowVisibility(next, scrollable && scrollLeft < maxScroll - EDGE_EPSILON);
  }

  function resetSliderToStart(slider) {
    const track = slider.querySelector('[data-tcn-track]');
    if (!track) return;
    track.classList.add('is-snap-off');
    track.scrollLeft = 0;
    requestAnimationFrame(() => {
      track.scrollLeft = 0;
      track.classList.remove('is-snap-off');
      updateArrowVisibility(slider);
    });
  }

  function scrollTrackTo(track, left, slider) {
    const target = Math.max(0, left);
    window.clearTimeout(Number(track.dataset.tcnSnapTimer || 0));

    track.classList.add('is-snap-off');
    track.scrollTo({ left: target, behavior: 'smooth' });

    const finish = () => {
      track.scrollLeft = target;
      track.classList.remove('is-snap-off');
      delete track.dataset.tcnSnapTimer;
      updateArrowVisibility(slider);
      track.removeEventListener('scrollend', finish);
    };

    track.addEventListener('scrollend', finish);
    track.dataset.tcnSnapTimer = String(window.setTimeout(finish, 450));
  }

  function initSlider(slider) {
    const track = slider.querySelector('[data-tcn-track]');
    const prev = slider.querySelector('[data-tcn-prev]');
    const next = slider.querySelector('[data-tcn-next]');
    if (!track || !prev || !next) return;

    const scrollByCard = (dir) => {
      if (dir < 0 && !prev.classList.contains('is-visible')) return;
      if (dir > 0 && !next.classList.contains('is-visible')) return;

      const card = track.querySelector('.tcn-card');
      if (!card) return;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      const amount = card.getBoundingClientRect().width + gap;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const scrollLeft = track.scrollLeft;
      // scrollLeft when the first card is flush with the track edge
      const firstFlushAt = card.offsetLeft;

      if (dir < 0) {
        // If the next card-step would reach the first card (or only the
        // spacer remains), go straight to the inset start in one click.
        // Mandatory snap otherwise parks on the flush first-card point.
        if (scrollLeft - amount <= firstFlushAt + EDGE_EPSILON) {
          scrollTrackTo(track, 0, slider);
          return;
        }
        track.scrollBy({ left: -amount, behavior: 'smooth' });
        return;
      }

      if (maxScroll - scrollLeft <= amount + EDGE_EPSILON) {
        scrollTrackTo(track, maxScroll, slider);
        return;
      }
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));

    let arrowRaf = 0;
    track.addEventListener(
      'scroll',
      () => {
        if (arrowRaf) return;
        arrowRaf = window.requestAnimationFrame(() => {
          arrowRaf = 0;
          updateArrowVisibility(slider);
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', () => updateArrowVisibility(slider), {
      passive: true,
    });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => updateArrowVisibility(slider));
      ro.observe(track);
    }

    resetSliderToStart(slider);
  }

  function initCardMedia(card) {
    const slides = Array.from(card.querySelectorAll('[data-tcn-slide]'));
    const indicators = Array.from(card.querySelectorAll('[data-tcn-indicator]'));
    const prev = card.querySelector('[data-tcn-media-prev]');
    const next = card.querySelector('[data-tcn-media-next]');
    if (slides.length <= 1) return;

    let index = 0;

    const updateMediaArrows = () => {
      if (prev) prev.hidden = index <= 0;
      if (next) next.hidden = index >= slides.length - 1;
    };

    const show = (nextIndex) => {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      indicators.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      updateMediaArrows();
    };

    if (prev) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (index <= 0) return;
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (index >= slides.length - 1) return;
        show(index + 1);
      });
    }

    indicators.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        show(i);
      });
    });

    updateMediaArrows();
  }

  function initTabsScroll(wrap) {
    const tabs = wrap.querySelector('[data-tcn-tabs]');
    const hint = wrap.querySelector('[data-tcn-tabs-hint]');
    if (!tabs || !hint) return;

    const updateHint = () => {
      const maxScroll = Math.max(0, tabs.scrollWidth - tabs.clientWidth);
      const scrollable = maxScroll > EDGE_EPSILON;
      const canScrollMore =
        scrollable && tabs.scrollLeft < maxScroll - EDGE_EPSILON;

      hint.classList.toggle('is-visible', canScrollMore);
      if (canScrollMore) {
        hint.removeAttribute('hidden');
        hint.setAttribute('aria-hidden', 'false');
      } else {
        hint.setAttribute('hidden', '');
        hint.setAttribute('aria-hidden', 'true');
      }
    };

    hint.addEventListener('click', (event) => {
      event.preventDefault();
      const amount = Math.max(120, Math.round(tabs.clientWidth * 0.45));
      tabs.scrollBy({ left: amount, behavior: 'smooth' });
    });

    tabs.addEventListener('scroll', updateHint, { passive: true });
    window.addEventListener('resize', updateHint, { passive: true });

    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(updateHint);
      ro.observe(tabs);
      wrap._tcnTabsRo = ro;
    }

    requestAnimationFrame(updateHint);
  }

  function boot(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SELECTOR) || event.target.closest(SELECTOR);
    if (section) {
      section.dataset.tcnBound = 'false';
      initSection(section);
    }
  });
})();
